import React, { useEffect, useRef, useState } from 'react'
import Menu from '../../Components/General/Menu/Menu'
import News from '../../Components/News/News'
import Footer from '../../Components/General/Footer/Footer'
import { newsData } from './NewsLogic/NewsLogic'
import { readCache, writeCache } from '../GeneralModule/swrCache'

/*
  Тот же stale-while-revalidate, что на главной, и тот же ключ: список
  новостей там уже кэшируется, а /news до этого ходила в сеть с нуля и до
  ответа держала пустую страницу.
*/
const NEWS_CACHE_KEY = 'nets_news_cache'

const NewsModule = () => {
  const cached = readCache(NEWS_CACHE_KEY)
  const [news, setNews] = useState(() => cached ?? undefined)
  const [status, setStatus] = useState(() => (cached ? 'ready' : 'loading'))
  // в catch нужно знать, показываем ли мы уже что-то из кэша
  const newsRef = useRef(news)
  newsRef.current = news

  useEffect(() => {
    let alive = true
    newsData()
      .then((res) => {
        if (!alive) return
        setNews(res.data)
        setStatus('ready')
        writeCache(NEWS_CACHE_KEY, res.data)
      })
      .catch((err) => {
        console.log(err)
        if (!alive) return
        setStatus(newsRef.current?.length ? 'ready' : 'error')
      })
    return () => { alive = false }
  }, [])

  return (
    <div>
      <Menu/>
      <News newsData={news} status={status} />
      <Footer/>
    </div>
  )
}

export default NewsModule
